import { ContinueButton } from 'components/continueButton/continueButton';
import { InputContainer } from 'components/inputContainer/inputContainer';
import { ValidationRequirement } from '../validationRequirement/validationRequirement';


import template from './createAccount.html';
import './createAccount.scss';


export const CreateAccount = angular
    .module('checkout.components.createAccount', [
        ContinueButton,
        InputContainer,
        ValidationRequirement
    ]).component('createAccount', {
        template,
        bindings: {
            showLoader: '<',
            showAccountCreatedMessage: '<',
            onDismissClicked: '&',
            onFormSubmit: '&'
        },
        controller: class CreateAccountCtrl {
            onPasswordInputFocused() {
                this.passwordInputFocused = true;
            }

            onPasswordInputBlurred() {
                this.passwordInputFocused = false;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/createAccount/createAccount.js